export default "__VITE_PUBLIC_ASSET__c1213bb0__"